export default function ImageSlide( props: { src: string, isMobile: boolean }) {
  return (
    <img
      src={props.src} className="imageSlide"
      height={props.isMobile ? 180 : 452} width={props.isMobile ? 400 : 736}
    />
  )
}